"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHourglassOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M20.05 14.25a18 18 0 001.64-1.44C24 10.52 24 6.53 24 4.39V4h2V2H6v2h2v.39c0 2 0 6.1 2.3 8.42a18.08 18.08 0 001.7 1.45c.84.74 1 .84 1 1.74s-.14 1-1.06 1.75a19.62 19.62 0 00-1.63 1.44C8.07 21.41 8 25 8 28H6v2h20v-2h-2c0-2.84-.08-6.57-2.3-8.81a18.08 18.08 0 00-1.65-1.45C19.16 17 19 16.9 19 16s.14-1 1.05-1.75zM18.8 19.3a17.13 17.13 0 011.48 1.3C21.93 22.27 22 25.51 22 28H10c0-2.61.06-5.75 1.72-7.39a15.75 15.75 0 011.48-1.3A3.64 3.64 0 0015 16a3.63 3.63 0 00-1.8-3.3 17.13 17.13 0 01-1.48-1.3C10 9.67 10 6.1 10 4.39V4h12v.39c0 1.85 0 5.29-1.72 7a14.58 14.58 0 01-1.48 1.3A3.64 3.64 0 0017 16a3.63 3.63 0 001.8 3.3z" })));
}
exports.default = SvgHourglassOutline;
//# sourceMappingURL=HourglassOutline.js.map